import { getOSM } from '../../OverworldAnimation.js';
// import SayHiToMom from './SayHiToMom.js';
// import BeforeIForget from './BeforeIForget.js';
// import RivalBattle1 from './RivalBattle1.js';

export default class BaseEvent {
    serialize() {
        return {
            className: this.constructor.name,
            identifier: this.identifier,
            isActive: this.isActive,
            complete: this.complete,
            autoComplete: this.autoComplete,
            nextState: this.nextState,
            initialEventState: this.initialEventState,
            initialObjectsState: this.initialObjectsState,
        };
    }

    static deserialize(data) {
        console.error('Unable to deserialize event', data);
        throw new Error('deserialize not implemented');
    }

    constructor({
        identifier,
        isActive = true,
        complete = false,
        autoComplete = false,
        nextState = null,
        objectsIdentifiers = [],
    }) {
        this.identifier = identifier;
        this.isActive = isActive;
        this.complete = complete;
        this.autoComplete = autoComplete;
        this.nextState = nextState;
        this.objectsIdentifiers = objectsIdentifiers;
        this.objects = [];
        this.initialEventState = this.captureInitialEventState();
        this.initialObjectsState = this.captureInitialObjectsState();
        this.map = null;
    }

    loadObjects() {
        this.objects = this.objectsIdentifiers.map((identifier) => {
            const obj = this.map.getObjectByIdentifier(identifier);

            if (!obj) {
                console.error(`Object ${identifier} not found in map ${this.map.identifier}`);
                return null;
            }
            return obj;
        });
    }

    runActions() {
        this.beforeRunActions();
        this.executeActions();
        this.afterRunActions();
    }

    beforeRunActions() {
        this.loadObjects();
        this.initialEventState = this.captureInitialEventState();
        this.initialObjectsState = this.captureInitialObjectsState();
    }

    executeActions() {
        throw new Error('executeActions not implemented');
    }

    afterRunActions() {
        if (this.autoComplete) {
            this.complete = true;
        }
        if (this.nextState) {
            getOSM().stateQueue.push(this.nextState);
        }
    }

    reset() {
        this.isActive = this.initialEventState.isActive;
        this.complete = this.initialEventState.complete;
        this.autoComplete = this.initialEventState.autoComplete;
        this.nextState = this.initialEventState.nextState;
        this.objects.forEach((object) => {
            switch (object.constructor.name) {
                case 'NPC':
                    this.resetNPC(object);
                    break;
                case 'Trainer':
                    this.resetTrainer(object);
                    break;
                default:
                    this.resetObject(object);
                    break;
            }
        });
    }

    getObject(identifier) {
        return this.objects.find((o) => o.identifier === identifier);
    }

    resetObject(object) {
        object.position = this.initialObjectsState.find((o) => o.identifier === object.identifier).position;
        object.visible = this.initialObjectsState.find((o) => o.identifier === object.identifier).visible;
    }

    resetNPC(npc) {
        npc.position = this.initialObjectsState.find((o) => o.identifier === npc.identifier).position;
        npc.sprite.visible = this.initialObjectsState.find((o) => o.identifier === npc.identifier).visible;
        npc.direction = this.initialObjectsState.find((o) => o.identifier === npc.identifier).direction;
    }

    resetTrainer(trainer) {
        this.resetNPC(trainer);
        trainer.party.forEach((pokemon) => {
            pokemon.heal();
        });
    }

    captureInitialEventState() {
        return {
            identifier: this.identifier,
            isActive: this.isActive,
            complete: this.complete,
            autoComplete: this.autoComplete,
            nextState: this.nextState,
        };
    }

    captureInitialObjectsState() {
        return this.objects.map((object) => {
            switch (object.constructor.name) {
                case 'NPC':
                    return {
                        identifier: object.identifier,
                        className: object.constructor.name,
                        position: {
                            x: object.position.x,
                            y: object.position.y,
                            z: object.position.z,
                        },
                        visible: object.sprite.visible,
                        direction: object.direction,
                    };
                case 'Trainer':
                    return {
                        identifier: object.identifier,
                        className: object.constructor.name,
                        position: {
                            x: object.position.x,
                            y: object.position.y,
                            z: object.position.z,
                        },
                        direction: object.direction,
                        visible: object.sprite.visible,
                    };
                default:
                    return {
                        identifier: object.identifier,
                        className: object.constructor.name,
                        position: object.position,
                        visible: object.visible,
                    };
            }
        });
    }

    preComplete() {
        return;
    }

    static async loadEvent(eventIdentifier) {
        switch (eventIdentifier) {
            case 'say_hi_to_mom': {
                const { default: SayHiToMom } = await import('./SayHiToMom.js');
                return new SayHiToMom();
            }
            case 'before_i_forget': {
                const { default: BeforeIForget } = await import('./BeforeIForget.js');
                return new BeforeIForget();
            }
            case 'rival_battle_1': {
                const { default: RivalBattle1 } = await import('./RivalBattle1.js');
                return new RivalBattle1();
            }
            case 'select_starter_grass': {
                const { default: SelectStarterGrass } = await import('./SelectStarterGrass.js');
                return new SelectStarterGrass();
            }
            case 'select_starter_fire': {
                const { default: SelectStarterFire } = await import('./SelectStarterFire.js');
                return new SelectStarterFire();
            }
            case 'select_starter_water': {
                const { default: SelectStarterWater } = await import('./SelectStarterWater.js');
                return new SelectStarterWater();
            }
            case 'dont_forget_lunchbox': {
                const { default: DontForgetLunchbox } = await import('./DontForgetLunchbox.js');
                return new DontForgetLunchbox();
            }
            case 'dont_forget_your_starter': {
                const { default: DontForgetYourStarter } = await import('./DontForgetYourStarter.js');
                return new DontForgetYourStarter();
            }
            case 'starter_picked': {
                const { default: StarterPicked } = await import('./StarterPicked.js');
                return new StarterPicked();
            }
            case 'thank_you_for_lunchbox': {
                const { default: ThankYouForLunchbox } = await import('./ThankYouForLunchbox.js');
                return new ThankYouForLunchbox();
            }
        }
        throw new Error(`Event ${eventIdentifier} not found`);
    }
}
